import React from 'react';
import "../assets/scss/components/message.scss"
import {ConfirmMessageIcon} from "../assets/icons/Icons";

const Message = (props) => {
    return (
        <div className={`message ${props.type} ${(props.className)?props.className : ''} ${(props.showIcon) ? 'has-icon' : ''}`}>
            {props.type === 'message-success' && props.showIcon &&
                <div className="message-icon">
                    <ConfirmMessageIcon/>
                </div>
            }
            {props.message}
        </div>
    );
};

export default Message;
